import { WX_OPEN_ID_KEY } from '../constants/pay';
import { getRequest } from './string';
import { Api, Codes } from '../api';
export const isWeiXin = () => {
  return !!window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i);
};
export const getOpenId = () => {
  if (isWeiXin()) {
    let openIdLocal = localStorage.getItem(WX_OPEN_ID_KEY);
    let openIdQuery = getRequest().openId;
    if (openIdLocal) {
      return openIdLocal;
    } else if (openIdQuery) {
      localStorage.setItem(WX_OPEN_ID_KEY, openIdQuery);
      return openIdQuery;
    } else {
      Api.get
        .getPaymentWechatOauth({
          return_url: window.location.origin + '/wx-code/' + encodeURIComponent(window.location.href),
          scope: 'base'
        })
        .then(res => {
          if (res.status === Codes.SUCCESS && res.data) {
            window.location.href = res.data.wechat_pay_oauth_url;
          }
        });
    }
  } else {
    return localStorage.getItem(WX_OPEN_ID_KEY);
  }
};
